<template lang="pug">
  .estimatead
    el-row(style="margin-bottom: 1rem;")
      el-col(:span="12")
        el-form(inline)
          el-form-item
            el-input(type="text", v-model="searchCreativeId", placeholder="请输入创意ID", :clearable="true")
          el-form-item
            el-select(v-model="selectedAdvId")
              el-option(v-for="item in advIdList" :key="item.value" :label="item.label" :value="item.value")
          el-form-item
            el-button(type="primary", @click="queryAdvertiserSettingAndGroup") 查询
    el-row
      el-col(:span="20")
        el-alert(:title="totalDesc", type="success", "dark", :closable="false")
      el-col(:span="4")
        el-popconfirm(title="确定更新当前分组统计数据？", @confirm="syncADvertiserSetting")
          el-button(type="warning", :loading="btnLoading", slot="reference") 更新数据
    el-table(:data="estimateadLogs", stripe, v-loading="dataLoading", @expand-change="handleExpand", row-key="groupId", :expand-row-keys="expandRowKeys")
      el-table-column(type="expand")
        template(slot-scope="scope")
          .inner-table-container
            el-table(ref="creativeTable", :data="scope.row.__details_logs__", v-loading="scope.row.__logDataLoading__", border, :highlight-current-row="true")
              el-table-column(label="时间")
                template(slot-scope="scope")
                  span {{$moment(scope.row.create_date).calendar()}}
              el-table-column(label="报告时间")
                template(slot-scope="scope")
                  span {{$moment(scope.row.reportTime).calendar()}}
              el-table-column(prop="advertisementName", label="广告名称")
              el-table-column(prop="creativeId", label="创意ID")
              el-table-column(prop="showCount", label="广告曝光量")
              el-table-column(prop="clickCount", label="广告点击量")
              el-table-column(prop="backActivateCount", label="自定义激活数")
              el-table-column(label="转化率")
                template(slot-scope="scope")
                  span(v-if="!scope.row.clickCount") -
                  span(v-else) {{(scope.row.backActivateCount/scope.row.clickCount * 100).toFixed(2)}}%
              el-table-column(label="营销平台-花费成本（元）")
                template(slot-scope="scope")
                  span {{(scope.row.spent).toFixed(2)}}
              el-table-column(label="营销平台-收入金额（元）")
                template(slot-scope="scope")
                  span {{(scope.row.firstDayRecoveryAdMonetizationC/100000).toFixed(2)}}
              el-table-column(prop="track_click_count", label="流量主内广告点击量")
              el-table-column(label="CPC")
                template(slot-scope="scope")
                  span(v-if="scope.row.track_click_count") {{(scope.row.firstDayRecoveryAdMonetizationC/100000 / scope.row.track_click_count).toFixed(2)}}
                  span(v-else) -
              el-table-column(label="预测ROI")
                template(slot-scope="scope")
                  span(v-if="scope.row.spent === 0") -
                  span(v-else) {{(scope.row.firstDayRecoveryAdMonetizationC/100000 / scope.row.spent).toFixed(2)}}
              el-table-column(label="回传所需cpc")
                template(slot-scope="scope")
                  span(v-if="scope.row.__reservation_rule__") {{scope.row.__reservation_rule__.cpc}}
                  span(v-else)
                    i 未设置
                  i.el-icon-edit.iconbtn-edit(@click="handleEditCPC(scope.row)")
              el-table-column(label="扣量控制")
                template(slot-scope="scope")
                  div(v-if="scope.row.__reservation_rule__")
                    div {{scope.row.__reservation_rule__.pass}}/{{scope.row.__reservation_rule__.skip}}/{{scope.row.__reservation_rule__.total}}
                    div {{(scope.row.__reservation_rule__.skip_percent * 100).toFixed(0)}}%
                  div(v-else)
                    i 未设置
                  i.el-icon-edit.iconbtn-edit(@click="handleItemSkipPercent('show', scope.row)")
      el-table-column(prop="groupId", label="广告组ID")
      el-table-column(prop="groupName", label="广告组名称")
      el-table-column(prop="showCount", label="广告曝光量")
      el-table-column(prop="clickCount", label="广告点击量")
      el-table-column(prop="backActivateCount", label="自定义激活数")
      el-table-column(label="转化率")
        template(slot-scope="scope")
          span(v-if="!scope.row.clickCount") -
          span(v-else) {{(scope.row.backActivateCount/scope.row.clickCount * 100).toFixed(2)}}%
      el-table-column(label="营销平台-花费成本（元）")
        template(slot-scope="scope")
          span {{(scope.row.spent).toFixed(2)}}
      el-table-column(label="营销平台-收入金额（元）")
        template(slot-scope="scope")
          span {{(scope.row.firstDayRecoveryAdMonetizationC/100000).toFixed(2)}}
      el-table-column(label="预测ROI")
        template(slot-scope="scope")
          span(v-if="scope.row.spent === 0") -
          span(v-else) {{(scope.row.firstDayRecoveryAdMonetizationC/100000 / scope.row.spent).toFixed(2)}}
    el-dialog(
      title="分组CPC回传条件"
      :visible.sync="cpcFormDialogVisible"
      width="30%"
    )
      el-alert(:title="'分组名称：'+currentCreative?.groupName", type="info", show-icon, :closable="false", :description="'创意ID:' + currentCreative?.creativeId")
      el-form.cpc-form(:inline="true")
        el-form-item(label="回传CPC条件 >=")
          el-input(type="text", v-model="cpcForm")
        el-form-item
          el-button(type="primary", size="mini", @click="saveCPCForm(currentCreative, cpcForm)") 保存
    el-dialog(title="修改扣量比例" :visible.sync="handleSkipPercentType" width="30%")
      el-form(:inline="true")
        el-form-item(label="扣量比例")
          el-select(v-model="skipPercentForm" placeholder="请选择")
            el-option(v-for="item in skipPercentOptions" :key="item" :label="`${Math.floor(item * 100)}%`" :value="item")
        el-form-item
          el-button(type="primary" @click="handleItemSkipPercent('handle', currentCreative, skipPercentForm)") 保存
</template>
    
<script>
import moment from 'moment'
export default {
  data() {
    return {
      btnLoading: false,
      dataLoading: false,
      estimateadLogs: [],
      totalDesc: '',
      cpcFormDialogVisible: false,
      cpcForm: 0.4,
      currentCreative: null,
      advertiserSetting: {},
      handleSkipPercentType: false,
      skipPercentForm: 0,
      dataUpdateTime: new Date(),
      skipPercentOptions: [0.00, 0.1, 0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65, 0.7, 0.8, 0.9],
      pageModel: {
        pageNo: 1,
        pageSize: 20,
        total: 0,
        condition: {
          creative_id: ''
        }
      },
      expandPageModel: {},
      expandRowKeys: [],
      searchCreativeId: '',
      selectedAdvId: 'a55df3169be0d4d4ec10',
      advIdList: [
        {
          label: 'tiquce03',
          value: 'a55df3169be0d4d4ec10'
        },
        {
          label: 'tiquce04',
          value: 'f752d8717aef9c38341f'
        },
        {
          label: 'tiquce06',
          value: '99d103565b3b4398c072'
        }
      ]
    }
  },
  mounted() {
    this.queryAdvertiserSettingAndGroup()
  },
  methods: {
    queryAdvertiserSetting(callback) {
      this.$service.ADService
        .getAdvertiserSetting(this.selectedAdvId)
        .then(res => {
          if (res.status === 200) {
            this.advertiserSetting = res.data.data
            callback && callback()
          }
        })
        .finally(() => {
          this.dataLoading = false
        })
    },
    getGroupIdByCreativeId() {
      return this.$service.EventTrackService.findGroupIdByCreative(this.selectedAdvId, this.searchCreativeId)
    },
    queryAdvertiserSettingAndGroup() {
      this.dataLoading = true
      this.expandRowKeys = []
      if(this.searchCreativeId) {
        this.getGroupIdByCreativeId()
          .then(res => {
            if(res.data.code === 0) {
              this.expandRowKeys.push(res.data.data)
              this.queryAndSet(res.data.data)
            } else {
              this.dataLoading = true
            }
          })
      } else {
        this.queryAndSet()
      }
    },
    queryAndSet(groupId) {
      this.$service.ADService
        .getAdvertiserSetting(this.selectedAdvId)
        .then(res => {
          this.totalDesc = ''
          this.estimateadLogs = []
          if (res.status === 200 && res.data.data) {
            this.pageModel.total = res.data.data.group_estimate_list.length
            this.dataUpdateTime = res.data.data.update_date
            this.advertiserSetting = res.data.data
            let groupEstimateList = res.data.data.group_estimate_list
            if(groupId) {
              groupEstimateList = res.data.data.group_estimate_list.filter(item => item.groupId === groupId)
            }
            this.estimateadLogs = groupEstimateList.map(item => {
              return {
                ...item,
                __logDataLoading__: false
              }
            })
            if(groupId) {
              setTimeout(() => {
                this.handleExpand(this.estimateadLogs[0], [this.estimateadLogs[0]], 1)
              }, 50)
            }
            let showCount = 0
            let clickCount = 0
            let backActivateCount = 0
            let spent = 0
            let firstDayRecoveryAdMonetizationC = 0
            this.estimateadLogs.forEach(item => {
              showCount += item.showCount
              clickCount += item.clickCount
              backActivateCount += item.backActivateCount
              spent += item.spent
              firstDayRecoveryAdMonetizationC += item.firstDayRecoveryAdMonetizationC
            })
            const descStrs = [
              '广告曝光量：' + showCount,
              '广告点击量：' + clickCount,
              '自定义激活数：' + backActivateCount,
              '转化率：' + (clickCount > 0 ? (backActivateCount / clickCount * 100).toFixed(2) + '%' : '-'),
              '花费成本：' + spent.toFixed(2),
              '收入金额：' + (firstDayRecoveryAdMonetizationC/100000).toFixed(2),
              'ROI：' + (spent > 0 ? (firstDayRecoveryAdMonetizationC/100000 / spent).toFixed(2) : '-')
            ]
            this.totalDesc = '今日汇总：【 ' + descStrs.join(' 】【 ') + ' 】' + '— 更新时间：' + (this.dataUpdateTime ? moment(this.dataUpdateTime).format('YYYY-MM-DD HH:mm:ss') : '-')
          }
        })
        .finally(() => {
          this.dataLoading = false
        })
    },
    handleExpand(row, expands, pageNo) {
      const rowIsExpand = expands.find(item => item.groupId === row.groupId)
      if(!rowIsExpand) {
        return
      }
      this.pageModel.pageNo = pageNo || this.pageModel.pageNo
      row.__logDataLoading__ = true
      this.pageModel.condition.group_id = row.groupId
      this.pageModel.condition.search_type = 'TIME'
      this.pageModel.condition.create_date = [
        moment(this.dataUpdateTime).add(-30, 'minutes').toDate(),
        moment(this.dataUpdateTime).add(30, 'minutes').toDate()
      ]
      this.pageModel.condition.advertiser_id = row.advertiserId
      this.$service.EventTrackService
        .queryEstimateDetails({
          pageNo: this.pageModel.pageNo,
          pageSize: this.pageModel.pageSize,
          condition: this.pageModel.condition
        })
        .then(res => {
          if (res.status === 201) {
            row.__details_logs__ = res.data.data.estimatead_logs.map(log => {
              return {
                ...log,
                __reservation_rule__: this.advertiserSetting.action_reservation_rule_list.find(rule => rule.creative_id == log.creativeId)
              }
            })
            if(this.searchCreativeId) {
              this.$refs.creativeTable.setCurrentRow(row.__details_logs__.find(log => log.creativeId == this.searchCreativeId))
            }
          }
        })
        .finally(() => {
          row.__logDataLoading__ = false
        })
    },
    handleEditCPC(creative) {
      this.cpcForm = creative.__reservation_rule__?.cpc || '0.4'
      this.currentCreative = creative
      this.cpcFormDialogVisible = true
    },
    handleItemSkipPercent(type, creative, skip_percent) {
        switch (type) {
            case "show":
                this.handleSkipPercentType = true
                this.currentCreative = creative
                this.skipPercentForm = creative.__reservation_rule__ || 0
                break;
            case "handle":
              this.$service.ADService
                    .updateADvertiserReservationSkipRule({
                      creative_id: creative.creativeId,
                      skip_percent: skip_percent,
                      adv_id: creative.advertiserId
                    })
                    .then((res) => {
                      if (res.status === 200) {
                        this.$message({
                          message: '已更新扣量规则',
                          type: 'success'
                        })
                        this.handleSkipPercentType = false
                        this.queryAdvertiserSetting(() => {
                          this.handleExpand(this.estimateadLogs.find(group => group.groupId === creative.groupId), '', 1)
                        })
                      }
                    })
              break;
        }
    },
    saveCPCForm(creative, cpc) {
      this.$service.ADService
        .updateADvertiserReservationRule({
          creative_id: creative.creativeId,
          cpc: cpc,
          adv_id: creative.advertiserId
        })
        .then((res) => {
          if (res.status === 200) {
            this.$message({
              message: '已更新CPC',
              type: 'success'
            })
            this.cpcFormDialogVisible = false
            this.queryAdvertiserSetting(() => {
              this.handleExpand(this.estimateadLogs.find(group => group.groupId === creative.groupId), '', 1)
            })
          }
        })
    },
    syncADvertiserSetting() {
      this.btnLoading = true
      this.$service.ADService
        .syncADvertiserSetting()
        .then((res) => {
          if (res.status === 200) {
            this.$message({
              message: '数据已更新',
              type: 'success'
            })
            this.queryAdvertiserSettingAndGroup()
          }
        })
        .finally(() => {
          this.btnLoading = false
        })
    }
  }
}
</script>

<style lang="less" scope>
.inner-table-container{
  padding: 0 1rem 2rem 1rem;
  background-color: #f3f3f3;
  border-top: 4px solid #ffc739;
}
.iconbtn-edit{
  margin-left: 6px;
  color: #409EFF;
  cursor: pointer;
}
.cpc-form{
  margin-top: 1rem;
}
</style>